import React, { lazy, Suspense } from "react";
import { RouteObject } from "react-router";
import { RouteLoader } from "@/shared/ui/RouteLoader";

// Eager load profile view (accessed frequently)
import ProfileScreen from "@/features/profile/pages/PersonalProfilePage";

// Lazy load profile settings (accessed less frequently)
const ProfileSettings = lazy(
  () => import("@/features/profile/pages/ProfileSettingsPage")
);

export const profileRoutes: RouteObject[] = [
  {
    path: "/profile",
    children: [
      {
        index: true,
        Component: ProfileScreen,
      },
      {
        path: "settings",
        element: (
          <Suspense
            fallback={<RouteLoader messageKey="common.loading_settings" />}
          >
            <ProfileSettings />
          </Suspense>
        ),
      },
    ],
  },
];
